import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../components/Icon";
import { buildUri, sizes } from "../../components/ResponsiveImage/uriTemplate";
import Chevron from "../../icons/chevron.svg";
import { LinkBehaviour } from "../LinkBehaviour";
import styles from "./LinkCard.module.scss";
export const LinkCard = ({ link, openIn, label, dataTestId, image, altText, onClick }) => {
    const handleClick = () => {
        return onClick(label);
    };
    return (_jsxs(LinkBehaviour, { href: link, target: openIn, rel: openIn === "_blank" ? "noreferrer" : "", className: styles.linkCard, "data-testid": dataTestId, onClick: handleClick, children: [_jsx("div", { className: styles.linkCardImageContainer, children: _jsx("img", { src: buildUri(image.src, sizes.small), className: styles.linkCardImage, alt: altText }) }), _jsx("div", { className: styles.linkCardLabel, "data-testid": "hero-card-label", children: label }), _jsx("div", { className: styles.linkCardChevron, children: _jsx(Icon, { component: Chevron }) })] }));
};
//# sourceMappingURL=LinkCard.js.map